import {
  arrayUnion,
  doc,
  FieldValue,
  getFirestore,
  increment,
  serverTimestamp,
  Timestamp,
  deleteField,
  DocumentReference,
  CollectionReference,
  collection,
  runTransaction,
  Transaction,
} from "firebase/firestore";

export class FirestoreUtils {
  /**
   * Create a Firestore server timestamp sentinel.
   */
  public static timestamp(date?: Date): Timestamp {
    if (date) return Timestamp.fromDate(date);
    return serverTimestamp() as Timestamp;
  }

  /**
   * Create an increment sentinel.
   *
   * @param amount The amount to increment by.
   */
  public static increment(amount: number): number {
    return increment(amount) as unknown as number;
  }

  /**
   * Create an array union sentinel to push an object into
   * a field on a document.
   *
   * @param elements List of elements to push.
   */
  public static push<T = FieldValue>(elements: T): T[] {
    return arrayUnion(elements) as unknown as T[];
  }

  /**
   * Create a sentinel to delete a field from a document.
   */
  public static delete<T = FieldValue>(): T {
    return deleteField() as unknown as T;
  }

  /**
   * Create a reference to a document.
   *
   * @param path The path to the document.
   */
  public static createDocRef<T>(path: string): DocumentReference<T> {
    return doc(getFirestore(), path) as DocumentReference<T>;
  }

  /**
   * Create a reference to a collection.
   *
   * @param path The path to the document.
   */
  public static createColRef<T>(path: string): CollectionReference<T> {
    return collection(getFirestore(), path) as CollectionReference<T>;
  }

  /**
   * Run a transaction.
   *
   * @param updateFunction The transaction to run.
   */
  public static runTransaction<T = unknown>(
    updateFunction: (tx: Transaction) => Promise<T>
  ) {
    return runTransaction(getFirestore(), updateFunction);
  }
}
